import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const result = await login(formData, 'admin');
    
    if (result.success) {
      navigate('/admin/dashboard');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-16 px-4" style={{ background: 'linear-gradient(135deg, #EDE9FE 0%, #F5F3FF 50%, #EDE9FE 100%)' }}>
      <div className="fixed inset-0 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle, #C4B5FD 1.2px, transparent 1.2px)', backgroundSize: '28px 28px', opacity: 0.4 }} />
      <div className="fixed top-0 right-0 pointer-events-none" style={{ width: '400px', height: '400px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(167,139,250,0.35) 0%, transparent 70%)', transform: 'translate(30%,-30%)' }} />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-xl" style={{ background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)' }}>
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <h2 className="text-3xl font-extrabold text-gray-900">Admin Portal</h2>
          <p className="text-purple-600 font-medium mt-1">Sign in to manage the system</p>
        </div>

        <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(16px)', border: '1px solid rgba(196,181,253,0.4)', boxShadow: '0 8px 40px rgba(139,92,246,0.15)' }}>
          <div className="p-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Admin Email</label>
                <input
                  type="email" name="email" autoComplete="email" required
                  placeholder="admin@example.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl text-sm text-gray-900 outline-none transition-all"
                  style={{ background: '#F5F3FF', border: '1.5px solid #DDD6FE' }}
                  onFocus={e => e.target.style.borderColor = '#8B5CF6'}
                  onBlur={e => e.target.style.borderColor = '#DDD6FE'}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Password</label>
                <input
                  type="password" name="password" autoComplete="current-password" required
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl text-sm text-gray-900 outline-none transition-all"
                  style={{ background: '#F5F3FF', border: '1.5px solid #DDD6FE' }}
                  onFocus={e => e.target.style.borderColor = '#8B5CF6'}
                  onBlur={e => e.target.style.borderColor = '#DDD6FE'}
                />
              </div>
              <button type="submit" disabled={loading} className="w-full py-3 rounded-xl font-bold text-white text-sm transition-all hover:scale-[1.02] disabled:opacity-60" style={{ background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', boxShadow: '0 6px 20px rgba(139,92,246,0.35)' }}>
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Signing in...
                  </span>
                ) : 'Sign In as Admin'}
              </button>
            </form>
            <div className="mt-5 text-center">
              <Link to="/" className="text-sm text-gray-500 hover:text-gray-700 transition-colors nav-link">← Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;

